export default "__VITE_ASSET__2a37ed04__"